module.exports = __webpack_public_path__ + "static/img/client4.40ab7163.jpg";